/**
 * Decodes all Unicode escape sequences (e.g., \u2013) in a string to their actual characters.
 * Handles any valid \uXXXX sequence.
 * @param str The input string possibly containing Unicode escapes
 * @returns The decoded string
 */
export function decodeUnicodeEscapes(str?: string): string {
  if (!str) return ""
  return str.replace(/\\u([\dA-Fa-f]{4})/g, (_match, grp) =>
    String.fromCharCode(parseInt(grp, 16)),
  )
}
